import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import TicketItem from './TicketItem';
import { base_url } from '../../Api/Api';
import Pagination from '@material-ui/lab/Pagination';
import SkltnTicketItem from './skltn/sklnTicketItem';
import { Link } from 'react-router-dom';

const Tickets = (props) => {

    const [state, setState] = useState({
        tickets: [],
        contentStatus: false,
        minPaginate: 0,
        maxPaginate: 10,
        countPaginate: 0,
    })

    useEffect(() => {

        window.scrollTo(0, 0)

        base_url.get(`tickets`)
            .then(response => {
                let dataLength = response.data.tickets.length;
                let countPaginate = Math.ceil(dataLength / 10);
                setState({
                    ...state,
                    tickets: response.data.tickets.reverse(),
                    contentStatus: response.data.tickets.length == 0,
                    countPaginate: countPaginate
                })
            })
            .catch(error => {
                if (error.response != undefined) {
                    if (error.response.status == 401) {
                        props.history.push(`/Entrance`)
                        localStorage.clear()
                        window.location.reload()
                    }
                }
            })

    }, []);

    const handleChange = (event, value) => {
        setTimeout(() => {
            window.scrollTo(0, 220)
        }, 100);
        setState({
            ...state,
            minPaginate: (value * 10) - 10 <= 0 ? 0 : (value * 10) - 10,
            maxPaginate: value * 10
        })
    };

    return (
        <div className="tickets">
            <div className="contain">
                <div className="ticketsDetail">
                    <div className="title">
                        <span className="ticketTtl">تیکت ها</span>
                        <Link to="/Tickets/CreateTicket">
                            <Button
                                variant="contained">ارسال تیکت جدید</Button>
                        </Link>
                    </div>
                    <div className="ticketBody">
                        <div className="menu">
                            <span>شناسه</span>
                            <span>عنوان</span>
                            <span>تاریخ ثبت</span>
                            <span>وضعیت</span>
                        </div>
                        <div className="items">
                            {state.tickets.length == 0 ?
                                state.contentStatus ?
                                    <span className="no-content">اطلاعاتی وجود ندارد</span>
                                    :
                                    <SkltnTicketItem />
                                :
                                state.tickets.slice(state.minPaginate, state.maxPaginate).map(item =>
                                    <TicketItem
                                        data={item} />
                                )}

                        </div>
                        <Pagination
                            count={state.countPaginate}
                            onChange={handleChange} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Tickets;